export default __webpack_public_path__ + "static/bannerbox.rauchmehl-dea7a5e1fe6b47cef214364e76ba8bd9.jpg";